/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, Nav, NavItem, NavLink } from "reactstrap";

function Footer() {
  return (
    <footer style={{background: 'none'}} className="footer">
      <Container>
        <div className="copyright">
          © 2024 Created by{" "}
          <a
          style={{textDecoration: 'underline'}}
            href="https://www.ddmwebdesigns.com"
            target="_blank"
          >
            DDM Web Designs
          </a>{" "}
          for expert realtors.
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
